import { brandName } from '@/mocks/animeData';

const values = [
  { icon: 'ri-quill-pen-line', title: '看得懂', desc: '不堆术语，把复杂剧情用大白话讲透。' },
  { icon: 'ri-eye-line', title: '不剧透', desc: '分集解说绝不剧透后续，深度解析明确标注范围。' },
  { icon: 'ri-team-line', title: '一起追', desc: '接受观众投稿与剪辑，共同完善每集重点。' },
];

const quotes = [
  { text: '追更到一半看分集解说，瞬间就懂了，太救急。', who: '@看动画不加辣' },
  { text: '结局独白的解析写得比原片还动人，看哭了。', who: '@屋顶吹风' },
  { text: '角色关系图更新得很勤，每次看完都恍然大悟。', who: '@板凳的板凳' },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
              <i className="ri-store-2-line"></i>关于本站
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              {brandName}，是一群把动画当正事研究的人
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们相信好动画值得被认真看懂。从第一季开播起，团队就坚持每一集都做分集解说、每一条伏笔都追根溯源、
              每一场名场面都反复拆解。你可以在这里快速看懂每集重点，也可以和我们一起挖掘藏在镜头背后的答案。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              无论是结局剧透、高能片段剪辑，还是角色关系梳理，我们都希望用轻松但不敷衍的方式，陪你把这部作品看得更过瘾。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl bg-background-100 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                    <i className={`${v.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-3xl bg-background-100 p-6 md:p-8">
            <h3 className="flex items-center gap-2 font-heading text-xl text-foreground-950">
              <i className="ri-chat-smile-3-line text-primary-500"></i>观众怎么说
            </h3>
            <div className="mt-5 space-y-4">
              {quotes.map((q) => (
                <figure key={q.who} className="rounded-2xl bg-background-50 p-4">
                  <div className="flex gap-1 text-secondary-500">
                    <i className="ri-star-fill text-sm"></i>
                    <i className="ri-star-fill text-sm"></i>
                    <i className="ri-star-fill text-sm"></i>
                    <i className="ri-star-fill text-sm"></i>
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                  <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                    “{q.text}”
                  </blockquote>
                  <figcaption className="mt-2 text-xs text-foreground-600">{q.who}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}